import { externalRedirect } from '@americanexpress/one-app-ducks';
import { getAkamaiDomain } from '../selectors/getConfigSelectors';
import { readUserSession } from '../utils/readUserSession';
import { readBenefits } from '../utils/readBenefits';
import { getFaasApiUrl } from '../selectors/getBaseUrlSelectors';

export const requireAuthForVr = ({ getState, dispatch }) => async (nextState, replace, cb) => {
  if (!global.BROWSER) {
    return cb();
  }
  const state = getState();
  const appDomain = getAkamaiDomain(state);
  const faasApiUrl = getFaasApiUrl(state);
  const { params: { locale } } = nextState;
  const lowerCaseLocale = locale ? locale.toLowerCase() : 'en-us';
  const homepageUrl = `${appDomain}/${lowerCaseLocale}/travel`;
  const isLoggedIn = await readUserSession(faasApiUrl);

  if (!isLoggedIn) {
    return cb();
  }

  const hasBenefits = await readBenefits(state);

  if (!hasBenefits && isLoggedIn) {
    dispatch(externalRedirect(homepageUrl));
  }

  return cb();
};

export default requireAuthForVr;
